import { useLocation, useNavigate } from "react-router-dom";
import { BarcodeIconWithModal } from "../../features";
import { ReactComponent as Logo_S } from "../../assets/images/icon/logo.svg";
import { ReactComponent as Bell } from "../../assets/images/icon/bell.svg";
import { ReactComponent as ArrowLeft } from "../../assets/images/icon/arrow-left.svg";
import { ReactComponent as Setting } from "../../assets/images/icon/setting.svg";
import { ReactComponent as Share } from "../../assets/images/icon/share.svg";
import { ReactComponent as Close } from "../../assets/images/icon/close.svg";
import { androidOpenSharedView, isLogin } from "../../utils";
import { useMyContext } from "../../entities/context";
import { useEffect, useRef, useState } from "react";
import { isAndroid } from "react-device-detect";

interface IProps {
  type?: "default" | "logo" | "closeIcon";
  rightType?: "default" | "bell" | "setting" | "share";
  title?: string | React.ReactNode;
  leftIcon?: boolean;
  middleIcon?: boolean;
  rightIcon?: boolean;
  thema?: "dark" | "white";
  position?: React.CSSProperties["position"] | undefined;
  style?: React.CSSProperties;
  styles?: { title?: React.CSSProperties; fixedTopDiv?: React.CSSProperties };
  leftIconOnClick?: React.MouseEventHandler<SVGSVGElement>;
  navigates?: {
    left?: string | number;
    middle?: string | number;
    right?: string | number;
  };
  containerRef?: React.RefObject<HTMLDivElement>;
  overOnClicks?: {
    left?: (e: any) => void;
    middle?: (e: any) => void;
    right?: (e: any) => void;
  };
  customShareData?: {
    title?: string;
    text?: string;
    url?: string;
    imgUrl?: string;
  };
  addHandleShareClick?: Function
}
const TopBar = ({
  type = "default",
  rightType = "default",
  title,
  leftIcon = true,
  middleIcon = true,
  rightIcon = true,
  thema = "white",
  position = "static",
  navigates,
  style,
  styles,
  leftIconOnClick,
  overOnClicks,
  containerRef,
  customShareData,
  addHandleShareClick,
}: IProps) => {
  const navigate = useNavigate();
  const { topHeight } = useMyContext();
  const topBarRef = useRef<HTMLDivElement>(null);
  const [fixedTopHeight, setFixedTopHeight] = useState<number>(48);
  const handleNavigation = (
    defaultValue: number | string,
    value?: number | string
  ) => {
    if (typeof value === "number") {
      navigate(value);
    } else if (typeof value === "string") {
      navigate(value);
    } else if (typeof defaultValue === "number") {
      navigate(defaultValue);
    } else if (typeof defaultValue === "string") {
      navigate(defaultValue);
    } else {
      navigate("/");
    }
  };

  const handleShare = async () => {
    addHandleShareClick?.()
    const shareData = {
      title: customShareData?.title ?? "공유 제목",
      text: customShareData?.text ?? "이 페이지를 확인해보세요!",
      url: customShareData?.url ?? window.location.href,
    };

    const androidShareData = {
      title: customShareData?.title ?? "공유 제목",
      text: customShareData?.text ?? "이 페이지를 확인해보세요!",
      url: customShareData?.url ?? window.location.href,
      imgUrl: customShareData?.imgUrl,
    };

    if (isAndroid) {
      androidOpenSharedView(androidShareData);
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log("공유 성공");
      } catch (err) {
        console.error("공유 실패", err);
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch (err) {
      console.error("클립보드 복사 실패", err);
    }
  };

  const isLogined = isLogin();

  const LeftIconToType = ({
    type,
  }: {
    type?: "default" | "logo" | "closeIcon";
  }) => {
    switch (type) {
      case "closeIcon":
        return (
          <>
            <Close
              style={{
                margin: "0 var(--space16)",
                padding: "12px",
              }}
              onMouseDown={(e) => e.preventDefault()}
              onClick={(e) =>
                overOnClicks?.left
                  ? overOnClicks?.left(e)
                  : handleNavigation(-1, navigates?.left)
              }
              width={24}
              height={24}
              stroke="var(--baseblack)"
            />
          </>
        );
      case "logo":
        return (
          <>
            {isLogined ? (
              <BarcodeIconWithModal
                onClick={(e) => overOnClicks?.left?.(e)}
                isNotModal
                color={thema === "dark" ? "black" : "white"}
                style={{
                  margin: "var(--space4) var(--space16)",
                  padding: "14.5px 9px",
                }}
              />
            ) : (
              <div
                style={{
                  width: 24,
                  height: 24,
                  padding: "var(--space12)",
                  margin: "var(--space4) var(--space16)",
                }}
              />
            )}
          </>
        );
      default:
        return (
          <>
            <ArrowLeft
              width={24}
              height={24}
              stroke="black"
              style={{
                cursor: "pointer",
                padding: "var(--space12)",
                marginInline: "var(--space16)",
              }}
              onClick={(e) =>
                overOnClicks?.left
                  ? overOnClicks?.left(e)
                  : handleNavigation(-1, navigates?.left)
              }
            />
          </>
        );
    }
  };
  const MiddleIconToType = ({
    type,
  }: {
    type?: "default" | "logo" | "closeIcon";
  }) => {
    switch (type) {
      case "logo":
        return (
          <Logo_S
            width={149.13}
            height={18}
            style={{ padding: "19px 0", margin: "0 auto", cursor: "pointer" }}
            fill={thema === "dark" ? "var(--baseblack)" : "var(--basewhite)"}
            onClick={() => {
              handleNavigation("/", navigates?.middle);
            }}
          />
        );
      default:
        return (
          <div
            className="title/t2"
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: 'center',
              height: 22,
              ...styles?.title,
            }}
          >
            {title}
          </div>
        );
    }
  };
  const RightIconToType = ({
    rightType,
  }: {
    rightType?: "default" | "bell" | "setting" | "share";
  }) => {
    switch (rightType) {
      case "bell":
        return (
          <Bell
            style={{
              padding: "var(--space12)",
              margin: "var(--space4) var(--space16)",
              cursor: "pointer",
            }}
            width={24}
            height={24}
            stroke={thema === "dark" ? "var(--baseblack)" : "var(--basewhite)"}
            onClick={(event) => {
              event.stopPropagation();
              handleNavigation("/notification", navigates?.right);
            }}
          />
        );
      case "setting":
        return (
          <Setting
            style={{
              padding: "var(--space12)",
              cursor: "pointer",
              marginInline: "var(--space16)",
            }}
            width={24}
            height={24}
            onClick={(event) => {
              event.stopPropagation();
              handleNavigation("/setting", navigates?.right);
            }}
          />
        );
      case "share":
        return (
          <Share
            style={{
              padding: "var(--space12)",
              cursor: "pointer",
              marginInline: "var(--space16)",
            }}
            width={24}
            height={24}
            stroke={thema === "dark" ? "var(--baseblack)" : "var(--basewhite)"}
            onClick={(event) => {
              event.stopPropagation();
              handleShare();
            }}
          />
        );
      default:
        return (
          <Bell
            style={{
              padding: "var(--space12)",
              margin: "var(--space4) var(--space16)",
              cursor: "pointer",
            }}
            width={24}
            height={24}
            stroke={thema === "dark" ? "var(--baseblack)" : "var(--basewhite)"}
            onClick={(event) => {
              event.stopPropagation();
              handleNavigation("/notification", navigates?.right);
            }}
          />
        );
    }
  };

  useEffect(() => {
    if (containerRef?.current) {
      setFixedTopHeight(containerRef?.current?.offsetHeight ?? 48);
    } else if (topBarRef?.current) {
      setFixedTopHeight(topBarRef?.current?.offsetHeight ?? 48);
    }
  }, [containerRef, topBarRef]);

  return (
    <>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: position,
          top: 0,
          paddingTop: topHeight + "px",
          zIndex: 2,
          width: "100%",
          maxWidth: "480px",
          transition: "background-color 0.3s, color 0.3s",
          backgroundColor:
            thema === "dark" ? "var(--basewhite)" : "transparent",
          ...style,
        }}
      >
        {leftIcon ? (
          <LeftIconToType type={type} />
        ) : (
          <div
            style={{
              width: "24px",
              padding: "12px",
              marginInline: "var(--space16)",
            }}
          ></div>
        )}
        {middleIcon ? (
          <MiddleIconToType type={type} />
        ) : (
          <div style={{ width: "24px", padding: "12px" }}></div>
        )}
        {rightIcon ? (
          <RightIconToType rightType={rightType} />
        ) : (
          <div
            style={{
              width: "24px",
              padding: "12px",
              marginInline: "var(--space16)",
            }}
          ></div>
        )}
      </div>
      {position === "fixed" && (
        <div
          style={{
            height: fixedTopHeight + Number(topHeight ?? 0),
            ...styles?.fixedTopDiv,
          }}
        ></div>
      )}
    </>
  );
};

export { TopBar };
